import { amountWithCommas, capitalize } from "./utils";

// Common messages
export const REMITTANCE = "OUTWARD REMITTANCE";
export const COPYRIGHT_MESSAGE = "Copyright © 2021 Axis Bank"
export const DISCLAIMER = "Disclaimer"
export const PRIVACY_POLICY = "Privacy Policy"
export const WELCOME_MESSAGE = "Welcome to Axis Bank"
export const REFERENCEID_TOOLTIP_TEXT = (partnerName: string) => `You may use this reference id to check if money is credited in your ${capitalize(partnerName)} account`;
export const REMITTANCE_AMOUNT_HELPER_TEXT = (limit: string, currency: string) => `You can enter maximum amount of ${currency} ${limit}`
export const TRANSACTION_DETAILS_HEADING = "Verify Transaction Details"
export const REFERENCEID = "Reference Id"
export const NAME = "Name"
export const PAN = "PAN"
export const EMAILID = "Email Id"
export const PURPOSE_OF_REMITTANCE = "Purpose of Remittance"
export const CURRENCY = "Currency"
export const USER_DOB = "Date of Birth"
export const USER_NAME = "Remitter Name"
export const REMITTANCE_AMOUNT = "Remittance Amount"
export const SELECT_ACC_NO = "Select Account Number for Payment"
export const SOURCE_OF_FUNDS = "Source of Funds"
export const HELLO = "HELLO!"
export const LAST_LOGIN = "Last Login"
export const MOBILE_NO = "MOBILE NUMBER"
export const FAQ = "FAQs"
export const LOGOUT = "Logout"
export const PAYMENT_FROM = "Payment From"
export const ACC_NUMBER = "Account Number"
export const ACC_BALANCE = "Account Balance"
export const PAYMENT_SUMMARY = "Payment Summary"
export const AMOUNT_REQUESTED = "Amount in Foreign Currency"	
export const AMOUNT_IN_INR_TEXT ="Amount in INR"	
export const AMOUNT_IN_INR= (rate:number) => amountWithCommas(rate)	
export const AMOUNT_IN_INR_ORG = (originalRate:number) => amountWithCommas(originalRate)
export const BANK_CHARGES = "Correspondent Bank Charges"
export const TAX_COLLECTED = "Tax Collected at Source"
export const FOREIGN_CURRENCY_TAX = "Foreign Currency Conversion tax"
export const GST = "GST"
export const COMISSION_AMOUNT = "Commission Amount"
export const TOTAL_AMOUNT = "Total Amount"
export const TNC = "Terms And Conditions"
export const ARGO_DECLARATION = "Axis Bank Remittance Online Application - Declaration"
export const TNC_ACCEPTED = "I HEREBY ACCEPT THE TERMS AND CONDITIONS"
export const ENTER_OTP = "Enter OTP"
export const SUCCESSFULLY_SUBMITTED = "Successfully Submitted"
export const LOGOUT_MESSAGE = "On logout you will have to restart the journey from partner portal"
export const TRANSACTION_VINTAGE_MESSAGE = "Your selected account is less than 12 month old. Please upload an alternate bank statement for a 12 month period in the next step in e-PDF format"
export const VINTAGE_PAGE_HEADING = "Your selected account vintage is less than 12 months"
export const VINTAGE_PAGE_DESCRIPTION = "Please select another account for funding, alternatively upload another bank’s ePDF for a 12 month period"
export const UPLOAD_BANK_STATEMENT = "Upload Bank Statement"
export const LIST_OF_BANKS = ['Allahabad Bank', 'Andhra Bank', 'Axis Bank', 'Bank of Bahrain and Kuwait', 'Bank of Baroda - Corporate Banking', 'Bank of Baroda - Retail Banking', 'Bank of India', 'Bank of Maharashtra', 'Canara Bank', 'Central Bank of India', 'City Union Bank', 'Corporation Bank', 'Deutsche Bank', 'Development Credit Bank', 'Dhanlaxmi Bank', 'Federal Bank', 'ICICI Bank', 'IDBI Bank', 'Indian Bank', 'Indian Overseas Bank', 'IndusInd Bank', 'ING Vysya Bank', 'Jammu and Kashmir Bank', 'Karnataka Bank Ltd', 'Karur Vysya Bank', 'Kotak Bank', 'Laxmi Vilas Bank', 'Oriental Bank of Commerce', 'Punjab National Bank - Corporate Banking', 'Punjab National Bank - Retail Banking', 'Punjab & Sind Bank', 'Shamrao Vitthal Co-operative Bank', 'South Indian Bank', 'State Bank of Bikaner & Jaipur', 'State Bank of Hyderabad', 'State Bank of India', 'State Bank of Mysore', 'State Bank of Patiala', 'State Bank of Travancore', 'Syndicate Bank', 'Tamilnad Mercantile Bank Ltd.', 'UCO Bank', 'Union Bank of India', 'United Bank of India', 'Vijaya Bank', 'Yes Bank Ltd'];
export const NTB_MAIN_HEADING = "Choose your Savings Account"
export const NTB_SUB_HEADING = "TAILOR-MADE FOR YOUR NEEDS"
export const ACCOUNT_PRIORITY = "Priority"
export const ACCOUNT_BURGUNDY = "Burgundy"
export const PRIORITY_BENEFIT_1 = "Annual Privilege worth Rs. 50,000. Airport lounge access, discounts on dining/movies, complimentary banking services & more"
export const PRIORITY_BENEFIT_2 = "Free Times Prime Membership worth Rs. 60,000. 1% additional flashback on online spends"
export const PRIORITY_BENEFIT_3 = "Privilege Credit Card with zero joining fees & travel/shopping vouchers worth Rs. 5000* on milestone spends"
export const PRIORITY_BENEFIT_4 = "Preferential Rates on Demat, Loans & more dedicated Relationship Manager"
export const PRIORITY_FOOTER = "*T&C apply | initial Funding of Rs 2,00,000"
export const BURGUNDY_BENEFIT_1 = "A dedicated Wealth Specialist and Relationship Manager"
export const BURGUNDY_BENEFIT_2 = "Suite of Power Packed Cards"
export const BURGUNDY_BENEFIT_3 = "Airport lounge access & concierge services"
export const BURGUNDY_BENEFIT_4 = "Host of offers on movies, golf, lessons, shopping & more"
export const BURGUNDY_BENEFIT_5 = "Complimentary virtual Debit Card & many more offers"
export const BURGUNDY_FOOTER = "*T&C apply | initial Funding of Rs 5,00,000"


// Placeholders, Button Messages and Dropdown messages
export const LOGIN_INPUT_PLACEHOLDER = "Login ID";
export const PASSWORD_INPUT_PLACEHOLDER = "Password"
export const FORGOT_PASSWORD = "Forgot password?"
export const LOGIN = "Login"
export const REGISTER = "First time user? Register"
export const ENABLE_LOGIN_ID = "Enable Login ID"
export const SOURCE_OF_FUNDS_ITEMS = [
  "Salaried",
  "Self Employed",
  "Rent Income",
  "Sale of Property",
  "Others"
]
export const SOURCE_OF_FUNDS_PLACEHOLDER = "Please enter source of funds here"
export const OTHER_SOURCE_OF_FUNDS_HELPER_TEXT = "Gift, Sale of Property, Bonus, etc"
export const REMITTER_NAME_HELPER_TEXT = "Enter your PAN name as per NSDL records to avoid transaction rejection. Verify the correct NSDL name with Form 16 or Form 26AS."
export const PROCEED = "Proceed"
export const CONTINUE = "Continue"
export const CONFIRM = "Confirm"
export const RESEND_OTP = "Resend OTP"
export const CURRENCIES = {
  INR: "INR",
  USD: "USD",
}


// Error messages
export const LOGIN_INVALID_CREDENTIALS = "Please enter valid Login ID & Password"
export const LOGIN_TXN_NOT_FOUND = "TransactionId not found. Invalid transaction"
export const LOGIN_USER_NOT_FOUND = "Entered credentials do not match to any user. USER IS INVALID"
export const LOGIN_USER_DISABLED = "Your login ID has been blocked. Use Enable login ID link below to reactivate and then retry."
export const LOGIN_CUSTOMER_NOT_FOUND = "Customer not found in database"
export const LOGIN_TXN_LOCKED = "Transaction is locked. Already utilised"
export const LIMIT_EXCEEDED = (limit: string, currency: string) => `You have exceeded the limit of ${currency} ${limit}`
export const INSUFFICIENT_FUNDS = 'Insufficient funds in your account. Please add suitable amount and refresh balance before continuing'
export const INCORRECT_ACCOUNT_FORMAT = "Incorrect Account Number format"
export const INCORRECT_SOURCE_OF_FUNDS = "Incorrect Source of Funds format"
export const INCORRECT_REMITANCE_AMOUNT = "Please enter a Valid amount"
export const COMMON_ERROR_MESSAGE = "Looks like you are lost."
export const INCORRECT_OTP = (attemptsLeft: number) => `Incorrect OTP, ${attemptsLeft} attempts remaining`
export const BROWSER_BACK_ALERT = "You will be logged out. Please re initiate the transaction from partner portal."
export const NEW_ACCOUNT_DISABLED = "Invalid transaction"
